import React from 'react';
import Link from 'next/link';

import cx from 'classnames';

import { useAppContext } from 'hooks/context/useAppContext';

import s from './SalonHeading.module.css';

type TProps = {
  className?: string;
};

const SalonHeading = ({ className }: TProps) => {
  const { publicUser } = useAppContext();

  return (
    <h1 className={cx(s.heading, s.title, className)}>
      {/* Need the fallback '' in case the user hits a 404 page result in no publicUser and the Link component choking froma lack of children */}
      <Link href="/">{publicUser?.business_name || ''}</Link>
    </h1>
  );
};

export { SalonHeading };
